<template>
    <!-- eslint-disable vue/valid-v-slot -->
    <v-card>
        <v-dialog v-model="dgReport" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-toolbar dark color="primary">

                <v-toolbar-title>Raporlama</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click="dgReport = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card>
                <!-- <v-card-title class="text-h5 grey lighten-2">
                    Reporlama
                </v-card-title> -->

                <v-card-text>

                    <!-- :aggregatorName="fil.aggregatorName" :rendererName="fil.rendererName" :valueFilter="fil.valueFilter"
                    :propsData="fil" :rows="fil.rows" :cols="fil.cols"
                    :rows="['username']"
                    :cols="['formSavedId']"
                    :data="[{color: 'blue', shape: 'circle'},{color: 'red', shape: 'triangle'}]" locale="tr"
                    :locales="localeClass" :aggregators="aggregatorsClass" aggregatorName="Adet"
                    :aggregatorName="fil.aggregatorName" :rendererName="fil.rendererName" :valueFilter="fil.valueFilter"

                    :rows="fil.rows" :cols="fil.cols" -->
                    <v-form ref="frmRapor">
                        <v-text-field label="Rapor Adı" v-model="rapor.name" :rules="nameRules"></v-text-field>
                        <vue-pivottable-ui :rendererName="pivodFilter.rendererName"
                            :valueFilter="pivodFilter.valueFilter" :rows="pivodFilter.rows"
                            :colOrder="pivodFilter.colOrder" :rowOrder="pivodFilter.rowOrder" :cols="pivodFilter.cols"
                            :vals="pivodFilter.vals" :aggregatorName="pivodFilter.aggregatorName"
                            :renderer-name="pivodFilter.rendererName" :data="dtReportData" ref="ptReport"
                            :renderers="renderers" locale="tr" :locales="localeClass" :aggregators="aggregatorsClass">
                        </vue-pivottable-ui>
                    </v-form>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="save">
                        Kaydet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table :headers="headers" :items="values" :items-per-page="10" class="elevation-1" show-expand
            @item-expanded="deneme" :single-expand="true" item-key="formId">

            <template v-slot:expanded-item="{ item }">
                <td :colspan="headers.length">
                    <!-- <v-btn @click="raporShow(item.formId)">Ekle</v-btn> -->
                    <v-list>
                        <v-subheader>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click="raporShow(item)">
                                        <v-icon large color="primary" class="mx-2" v-bind="attrs" v-on="on">
                                            mdi-chart-box-plus-outline
                                        </v-icon></v-btn>
                                </template>
                                <span>Yeni Rapor Ekle</span>
                            </v-tooltip>

                            RAPORLAR</v-subheader>
                        <v-list-item-group color="primary">
                            <v-list-item v-for="(itemRp) in expandValues" :key="itemRp.formRaporId">
                                <!-- <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon> -->
                                <v-list-item-content>
                                    <v-list-item-title v-text="itemRp.name"></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-menu bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list>
                                            <v-list-item @click="editFormRapor(item, itemRp)">
                                                <v-list-item-icon>
                                                    <v-icon large>mdi-table-edit</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>Rapor Güncelle</v-list-item-title>
                                            </v-list-item>

                                            <v-list-item @click="deleteFormRapor(item, itemRp)">
                                                <v-list-item-icon>
                                                    <v-icon large>mdi-image-remove-outline</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>Rapor Sil</v-list-item-title>
                                            </v-list-item>



                                        </v-list>
                                    </v-menu>



                                    <!-- <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click="editFormRapor(item, itemRp)" v-bind="attrs" v-on="on">
                                                <v-icon color="red lighten-1">mdi-table-edit</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Rapor Güncelle</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click="deleteFormRapor(item, itemRp)" v-bind="attrs" v-on="on">
                                                <v-icon color="red lighten-1">mdi-image-remove-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Rapor Sil</span>
                                    </v-tooltip> -->

                                </v-list-item-action>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                    <!-- <table >
                        <tr>
                            <th>Rapor Adı</th>
                            <th>Düzenleme</th>
                        </tr>
                        <tr v-for="itemRp in expandValues" :key="itemRp.formRaporId">
                            <td>{{ itemRp.name }}</td>
                            <td></td>
                        </tr>
                    </table> -->
                    <!-- <v-alert type="info" dense text>
                        {{ mainUrl }}/formview/{{ item.formId }}
                    </v-alert> -->
                </td>
            </template>
        </v-data-table>
    </v-card>


</template>

<script>
import FormService from '@/services/FormService';
import { VuePivottableUi, PivotUtilities, Renderer } from 'vue-pivottable'
import { aggregators, locales } from '@/plugins/pivotUtils';
import PlotlyRenderer from '@vue-pivottable/plotly-renderer'
import FormRaporService from '@/services/FormRaporService';
//import {locales} from 'vue-pivottable/src/helper/utils'


import 'vue-pivottable/dist/vue-pivottable.css'
export default {
    components: { VuePivottableUi },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Yeni Form Tanımlama' : 'Form Güncelle'
        },
        renderers() {
            return (() => ({
                ...Renderer.TableRenderer,
                'Grouped Column Chart': PlotlyRenderer['Grouped Column Chart'],
                'Stacked Column Chart': PlotlyRenderer['Stacked Column Chart'],
                'Grouped Bar Chart': PlotlyRenderer['Grouped Bar Chart'],
                'Stacked Bar Chart': PlotlyRenderer['Stacked Bar Chart'],
                'Line Chart': PlotlyRenderer['Line Chart'],
                'Dot Chart': PlotlyRenderer['Dot Chart'],
                'Area Chart': PlotlyRenderer['Area Chart'],
                'Scatter Chart': PlotlyRenderer['Scatter Chart'],
                'Multiple Pie Chart': PlotlyRenderer['Multiple Pie Chart']
            }))()
        }
    },
    data() {
        return {
            nameRules: [
                v => !!v || 'Boş Bırakılamaz',

            ],
            selectedRow: [],
            expandValues: [],
            rapor: { value: null, name: null, formId: null, formRaporId: null },
            selectedItem: { formId: "" },
            selectedFormRapor: null,
            pivodFilter: {
                aggregatorName: "Toplam",
                "rendererName": "Table",
                rowOrder: "key_a_to_z",
                colOrder: "key_a_to_z",
                vals: [

                ],
                "cols": [

                ],
                rows: [

                ],
                attributes: [
                    // "KayitId",
                    // "onayDurum",
                    // "OnayDurumId",
                    // "username",
                    // "KullaniciId",
                    // "Birim",
                    // "Faaliyet Sayısı",
                    // "Faaliyet Tarihi",
                    // "Faaliyetden yetkili personel",
                    // "İl",
                    // "İlçe"
                ],
                valueFilter: {
                    // "KayitId": {},
                    // "onayDurum": {
                    //     "Onaya Sunuldu": false
                    // },
                    // "OnayDurumId": {},
                    // "username": {},
                    // "KullaniciId": {},
                    // "Birim": {},
                    // "Faaliyet Sayısı": {},
                    // "Faaliyet Tarihi": {},
                    // "Faaliyetden yetkili personel": {},
                    // "İl": {},
                    // "İlçe": {}
                },
                "renderer": null
            },
            localeClass: { ...locales },
            aggregatorsClass: null,
            orginal: null,
            filter: {
                valueFilter: null,
                rows: [],
                cols: [],
            },

            customAggregators: {},
            dgReport: false,
            dtReportData: [],
            values: [],
            headers: [
                //{ text: 'Form Id', value: 'formId', sortable: false },
                //{ text: 'Form Ekle', value: 'new', sortable: false },
                {
                    text: 'Form Adı',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Başlama Tarihi', value: 'baslamaTarihi', sortable: false },
                { text: 'Bitiş Tarihi', value: 'bitisTarihi', sortable: false },
                { text: 'Değerlendirme Son Tarihi', value: 'degerlendirmeSonTarihi', sortable: false },
                { text: 'Durum', value: 'durum.name', sortable: false },
                //{ text: 'Actions', value: 'actions', sortable: false },

            ],
        }
    },
    created() {
        this.aggregatorsClass = this.localeClass["tr"].trAggregators;


        this.dataBind();

    },

    methods: {
        editFormRapor(formItem, paramFormRapor) {
            console.log("Edit", paramFormRapor);
            this.selectedItem = formItem;
            this.rapor = { ...paramFormRapor };
            FormService.listReportData(paramFormRapor.formId).then((result) => {
                // this.dtReportData = result.data;
                // this.dgReport = true;
                this.dtReportData = result.data;

                this.pivodFilter = JSON.parse(paramFormRapor.value)
                this.dgReport = true;
            }).catch((err) => {
                console.log("Error:", err);
            });


        },
        deleteFormRapor(formItem, paramFormRapor) {
            console.log("deleteFormRapor", paramFormRapor);
            if (confirm('Silmek isteğinize emin misiniz.')) {
                FormRaporService.delete(paramFormRapor.formRaporId).then((result) => {
                    this.expandDataBind(paramFormRapor.formId);
                    this.$toast.success('Başarılı bir şekilde silinmiştir.');
                }).catch((err) => {

                });
            }


        },

        expandDataBind(formId) {
            FormRaporService.listFormRaporByFormId(formId).then((result) => {
                this.expandValues = result.data;
            }).catch((err) => {

            });
        },
        deneme(param) {

            if (param.value) {
                this.expandDataBind(param.item.formId);
                // FormRaporService.listFormRaporByFormId(param.item.formId).then((result) => {
                //     this.expandValues = result.data;
                // }).catch((err) => {

                // });
            }

            //  console.log("Item", param.item, "Value", param.value);
        },
        save() {


            if (!this.$refs.frmRapor.validate()) {
                this.$toast.warning("Rapor ismi boş bırakılamaz.")
                return false;
            }

            this.rapor.value = JSON.stringify(this.$refs.ptReport.propsData);
            this.rapor.formId = this.selectedItem.formId;
            FormRaporService.save(this.rapor).then((result) => {
                this.$toast.success('Başarılı bir şekilde kaydedilmiştir.');
                this.expandDataBind(this.rapor.formId);
                this.dgReport = false;
                this.rapor.value = null;
            }).catch((err) => {

            });
        },
        raporShow(item) {
            this.selectedItem = item;
            this.rapor = { value: null, name: null, formId: item.formId, formRaporId: null }

            FormService.listReportData(item.formId).then((result) => {
                this.dtReportData = result.data;
                this.dgReport = true;


            }).catch((err) => {
                console.log("Error:", err);
            });
        },
        dataBind() {
            FormService.AdminFormlari().then((result) => {
                this.values = result.data;
                //  console.log("listForm", result.data);

                // FilterUserService.PbsPersonels().then((result) => {

                //   this.personels = result.data;
                // }).catch((err) => {

                // });


            }).catch((err) => {
                console.log("Error:", err);
            });
            //   DurumService.listDurums().then((result) => {
            //     this.durums = result.data;
            //   }).catch((err) => {

            //   });


        },
    }
}
</script>

<style></style>